/**
 * dnd-kit's own screen-reader layer, turned off, for the two answer boards
 * that can be dragged: `MatchingBoard` and `AssociationOrdering`.
 *
 * Dragging is a pointer enhancement on both, never the keyboard path — the
 * dropdowns and the buttons are that — so the library has nothing true to
 * say. Its default instructions describe a keyboard drag ("press space or
 * enter to pick up") that neither board offers, and its default
 * announcements read element ids aloud ("Picked up draggable item
 * question-q4-right-gas"). Each board already says what a drop did, in words
 * and in the reader's language, from its own live region.
 */
export const SILENT_DRAG_ACCESSIBILITY = {
    announcements: {
        onDragStart: () => undefined,
        onDragOver: () => undefined,
        onDragEnd: () => undefined,
        onDragCancel: () => undefined,
    },
    screenReaderInstructions: { draggable: '' },
};
//# sourceMappingURL=drag.js.map